import { createListenerMiddleware } from '@reduxjs/toolkit';
import { NotificationTypeEnum } from 'Components/designSystem';
import i18n from 'i18next';
import { hideToast, showToast, ToastOptions } from 'modules/ToastManager';

import { acceptAvailabilityThunk } from './thunks';

const availabilityUpdateMiddleware = createListenerMiddleware();

const SUCCESS_NOTIFICATION_DURATION = 10000;

const TOAST_ID = 'update-availability-succeeded';

availabilityUpdateMiddleware.startListening({
    actionCreator: acceptAvailabilityThunk.fulfilled,
    effect: async (_, listenerAPI) => {
        listenerAPI.dispatch(hideToast({ toastId: TOAST_ID }));

        await listenerAPI.delay(500);

        const toast: ToastOptions = {
            id: TOAST_ID,
            type: NotificationTypeEnum.Success,
            description: i18n.t('updatedSuccessfully', { ns: 'candidateAvailability' }),
            duration: SUCCESS_NOTIFICATION_DURATION
        };

        listenerAPI.dispatch(showToast({ toast }));
    }
});

export default availabilityUpdateMiddleware;
